import { HttpInterceptors } from "./http.interceptor";

export class DashboardService extends HttpInterceptors {
	async weekDays (payload) {
		const response = await this.axios.get("dashboard/weekDays", { params: { payload }});
		return response.data;
	}

	async calendar (payload) {
		const response = await this.axios.get("dashboard/calendar", { params: { payload }});
		return response.data;
	}

}
